export default __webpack_public_path__ + "c8eebf8d1426ab745bcc60e7dd91a808.png";